var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPromptAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 2L19.4603 4.74284L22.2031 6L19.4624 7.24444L18.2031 10L16.9439 7.24444L14.2031 6L16.946 4.74284L18.2031 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3613 12.4639C18.1635 12.4639 17.9654 12.5 17.7676 12.5723C17.5698 12.6445 17.3903 12.7624 17.2285 12.9248L11.667 18.4609V21.7031H14.9092L20.4453 16.167C20.6071 16.0051 20.7242 15.8226 20.7969 15.6191C20.8695 15.4155 20.9062 15.212 20.9062 15.0088C20.9062 14.8109 20.8655 14.613 20.7842 14.415C20.7028 14.2171 20.5899 14.037 20.4453 13.875L19.5205 12.9502C19.3589 12.7882 19.1789 12.6669 18.9814 12.5859C18.784 12.505 18.5772 12.4639 18.3613 12.4639ZM17.2383 17.0576L14.2363 20.084H13.2871V19.1338L16.3125 16.1328L17.2383 17.0576ZM2.5 13.667V15.9424H9.86426V13.667H2.5ZM2.5 9.48242V11.7568H16.7422C16.4832 11.5415 16.2695 11.2686 16.124 10.9502L15.4531 9.48242H2.5ZM2.5 5.29688V7.57227H12.5459C12.1511 7.1561 11.918 6.59887 11.917 6.00391C11.9166 5.7596 11.9565 5.52177 12.0293 5.29688H2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromptAssistant);
export default __webpack_public_path__ + "static/media/icon-prompt-assistant.54f54e4f1d11436e3a49c7d1be64c42a.svg";
export { ForwardRef as ReactComponent };